<template>
  <form
    v-if="show"
    class="modal-card"
    style="width: 600px;"
    @submit.prevent="updateReasonCancellation"
  >
    <header class="modal-card-head">
      <p class="modal-card-title has-text-primary">
        Cancelación de CFDI
      </p>
    </header>
    <section class="modal-card-body">
      <div class="column is-10">
        <BField label="Motivo de cancelación">
          <BSelect
            id="cancellation.reason"
            v-model="cancellation.reason"
          >
            <option
              v-for="option in getReasonCancellationCatalog()"
              :key="option.key"
              :value="option.key"
            >
              {{ option.key }} - {{ option.value }}
            </option>
          </BSelect>
        </BField>
      </div>
      <template v-if="cancellation.reason === cfidWithRelation">
        <div class="column">
          <BField label="Folio fiscal (UUID) que sustituye al comprobante">
            <BAutocomplete
              v-model="cancellation.uuids"
              :data="filteredInvoices"
              field="cfdi.complement.digitalTaxStamp.uuid"
              class="searcher-dropdown"
              :pattern="pattern"
              expanded
              open-on-focus
              @typing="getFilteredInvoices"
              @select="option => selected = option"
            >
              <template slot-scope="props">
                <div class="media">
                  <div class="media-content">
                    Serie: {{ props.option.cfdi.voucherSeries }} -
                    Folio: {{ props.option.cfdi.voucherConsecutive }} <br>
                    <strong>
                      UUID: {{ props.option.cfdi.complement.digitalTaxStamp.uuid }}
                    </strong>
                  </div>
                </div>
              </template>
            </BAutocomplete>
          </BField>
        </div>
      </template>
      <footer class="modal-card-foot">
        <Button
          type="button"
          class="button"
          @click="$modalForm({ show: false })"
        >
          Cerrar
        </Button>
        <Button
          type="submit"
          class="button is-secondary"
          :disabled="!cancellation.reason"
        >
          Cancelar documento
        </Button>
      </footer>
    </section>
  </form>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import utils from '../../../lib/utils';

const reasonCancellation = [
  { key: '01', value: 'Comprobante emitido con errores con relación' },
  { key: '02', value: 'Comprobante emitido con errores sin relación' },
  { key: '03', value: 'No se llevó a cabo la operación' },
  { key: '04', value: 'Operación nominativa relacionada en una factura' },
];

export default {
  name: 'ReasonCancellation',
  data() {
    return {
      invoice: '',
      invoices: [],
      filteredInvoices: [],
      cancellation: {
        reason: '',
        uuids: '',
      },
      cfidWithRelation: '01',
      reasonCancellationCatalog: reasonCancellation,
      pattern: '^[a-f0-9A-F]{8}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{12}$',
      reasonCancellationPayroll: ['01', '02'],
    };
  },
  computed: {
    ...mapState({
      show: state => state.modalForm.show,
      props: ({ modalForm }) => modalForm.props,
    }),
  },
  watch: {
    'cancellation.reason': function cancellationReason(value) {
      if (value === this.cfidWithRelation && !this.invoices.length) {
        this.cancellation.uuids = [];
        this.getInvoices();
      } else {
        delete this.cancellation.uuids;
      }
    },
  },
  mounted() {
    this.invoice = this.props.invoice;
  },
  methods: {
    ...mapActions({
      searchInvoices: 'invoices/searchInvoices',
      cancelByUuid: 'invoice/cancelByUuid',
      updateCancellation: 'invoice/updateCancellation',
    }),
    getReasonCancellationCatalog() {
      return this.invoice.voucherType === 'N' ? this.reasonCancellationCatalog.filter(
        ({ key }) => this.reasonCancellationPayroll.includes(key),
      ) : this.reasonCancellationCatalog;
    },
    async getInvoices() {
      const list = await this.searchInvoices({
        filter: utils.getDocumentType(this.invoice),
        stamped: true,
      });

      this.invoices = list.filter(invoices => (invoices.cfdi.complement.digitalTaxStamp.uuid
        !== this.invoice.complement.digitalTaxStamp.uuid));

      this.filteredInvoices = this.invoices;
    },
    getFilteredInvoices(value) {
      this.filteredInvoices = this.invoices.filter(invoice => (
        invoice.cfdi.complement.digitalTaxStamp.uuid
          .toString()
          .toLowerCase()
          .indexOf(value.toLowerCase()) >= 0
      ));
    },
    async updateReasonCancellation() {
      try {
        const payload = await this.updateCancellation({
          uuid: this.invoice.id,
          cancellation: this.cancellation,
        });

        if (payload) {
          await this.cancel();
        }
      } catch (error) {
        this.$danger({
          message: 'Ocurrió un error al actualizar el motivo de cancelación.',
        });
      }
    },
    async cancel() {
      this.$modalForm({ show: false });

      const now = new Date();

      this.$store.commit('ui/addNotification', {
        type: 'success',
        content: 'Cancelando documento <br> Esperando respuesta, esto puede tomar un momento.',
        dateTime: now,
      });

      try {
        await this.cancelByUuid(this.invoice.id);

        this.$store.commit('ui/deleteNotification', now);

        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content: 'Se ha realizado el proceso satisfactoriamente.',
        });
      } catch (error) {
        this.$store.commit('ui/deleteNotification', now);

        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: `
            Ocurrió un error al tratar de cancelar el documento. <br>
            ${error.message}
          `,
        });
      }
    },
  },
};
</script>

<style scoped>

</style>
